import {getAudioList} from '../CHELAudio';

import {
  HEL_AUDIO_TYPE_SE,
  HEL_AUDIO_TYPE_SYSTEMSE,
  HEL_AUDIO_TYPE_VIDEO,
  HEL_AUDIO_TYPE_VOICE,
  HEL_AUDIO_TYPE_WORLD
} from './const';
import {
  getMixerDistanceAt,
  getMixerFaderSettingAt,
  getMixerMuteAt,
  getMixerSettingAt,
  getMixerMasterVolume,
  getMixerTab,
  setMixerDistanceAt,
  setMixerFaderSettingAt,
  setMixerMuteAt,
  setMixerRealSettingAt,
  setMixerSettingAt
} from './dataOps';
import {hel_video_SetVolume} from './device';
import {hel_set_cookie} from './shared';
import {hel_skyway_SetMixerVolume} from './skyway';

/**
 * @param type
 * @param volume
 * @param fadeVolume
 * @param distanceVolume
 * @param mute
 */
export const hel_mixer_SetVolume = (
  type: number,
  volume: number,
  mastervolume: number,
  fadeVolume: number,
  distanceVolume: number,
  mute: number
) => {
  const realVolume =
    getMixerTab() * volume * mastervolume * fadeVolume * distanceVolume * (mute !== 0 ? 0.0 : 1.0);

  // SetVolume前に設定を反映する必要がある
  switch (type) {
    case HEL_AUDIO_TYPE_WORLD:
    case HEL_AUDIO_TYPE_VOICE:
    case HEL_AUDIO_TYPE_SE:
    case HEL_AUDIO_TYPE_SYSTEMSE:
    case HEL_AUDIO_TYPE_VIDEO:
      setMixerSettingAt(volume, type);
      setMixerRealSettingAt(realVolume, type);
      setMixerFaderSettingAt(fadeVolume, type);
      setMixerDistanceAt(distanceVolume, type);
      setMixerMuteAt(mute, type);
      break;
    default:
      return;
  }

  switch (type) {
    case HEL_AUDIO_TYPE_WORLD:
      hel_set_cookie('mixervolume_world', volume as unknown as string);
      hel_set_cookie('mixermute_world', mute as unknown as string);
      break;

    case HEL_AUDIO_TYPE_VOICE:
      hel_skyway_SetMixerVolume(realVolume);

      hel_set_cookie('mixervolume_voice', volume as unknown as string);
      hel_set_cookie('mixermute_voice', mute as unknown as string);
      break;

    case HEL_AUDIO_TYPE_SE:
      hel_set_cookie('mixervolume_se', volume as unknown as string);
      hel_set_cookie('mixermute_se', mute as unknown as string);
      break;

    case HEL_AUDIO_TYPE_SYSTEMSE:
      hel_set_cookie('mixervolume_systemse', volume as unknown as string);
      hel_set_cookie('mixermute_systemse', mute as unknown as string);
      break;

    case HEL_AUDIO_TYPE_VIDEO:
      hel_video_SetVolume(realVolume);

      hel_set_cookie('mixervolume_video', volume as unknown as string);
      hel_set_cookie('mixermute_video', mute as unknown as string);
      break;

    default:
      return;
  }
};

const hel_mixer_UpdateByType = (
  type: typeof HEL_AUDIO_TYPE_VOICE | typeof HEL_AUDIO_TYPE_VIDEO
) => {
  hel_mixer_SetVolume(
    type,
    getMixerSettingAt(type),
    getMixerMasterVolume(),
    getMixerFaderSettingAt(type),
    getMixerDistanceAt(type),
    getMixerMuteAt(type)
  );
};

export const hel_mixer_UpdateAll = () => {
  hel_mixer_UpdateByType(HEL_AUDIO_TYPE_VOICE);
  hel_mixer_UpdateByType(HEL_AUDIO_TYPE_VIDEO);

  const audioList = getAudioList();
  for (let index = 0; index < audioList.length; index++) {
    if (audioList[index] === null) continue;

    const type = audioList[index]?.getType()!;
    if (type !== HEL_AUDIO_TYPE_VOICE && type !== HEL_AUDIO_TYPE_VIDEO) {
      throw new Error(
        `Expected HEL_AUDIO_TYPE_VOICE (${HEL_AUDIO_TYPE_VOICE}) or HEL_AUDIO_TYPE_VIDEO (${HEL_AUDIO_TYPE_VIDEO}), but got “${type}”.`
      );
    }

    const realVolume =
      getMixerSettingAt(type) *
      getMixerFaderSettingAt(type) *
      getMixerDistanceAt(type) *
      (getMixerMuteAt(type) !== 0 ? 0.0 : 1.0);

    audioList[index]?.setVolume(realVolume);
  }
};
